export const SQL_BASICS_COURSE_UUID = "6a4a747b-d7d9-4d22-a17c-8ebe974a78e8";
export const SQL_BASICS_COURSE_PATH = "/courses/sql/basics";
